import { z } from 'zod';

export type DealerCreateForm = {
    holding_id?: number,
    sap_code: string,
    city_id?: number,
    name: string,
    is_certified: 0 | 1,
    is_hyundai_dealer: 0 | 1,
    is_genesis_dealer: 0 | 1,
    phone?: string,
    email?: string,
    site?: string,

    legal_name: string,
    address: string,
    inn: string,
    kpp: string,
    ogrn: string,
    bank_account: string,
    bank_name: string,
    correspondent_account: string,
    bank_identification_code: string,
    signer_fio: string,
    signer_position: string,
    signer_basis: string,
    signer_basis_2?: string,
    signatory_position_and_name: string,
    contract_number: string,
    contract_date: string,
};

export type DealerCreateFormErrors = {
    holding_id?: string[],
    sap_code?: string[],
    city_id?: string[],
    name?: string[],
    is_certified?: string[],
    is_hyundai_dealer?: string[],
    is_genesis_dealer?: string[],
    phone?: string[],
    email?: string[],
    site?: string[],

    legal_name?: string[],
    address?: string[],
    inn?: string[],
    kpp?: string[],
    ogrn?: string[],
    bank_account?: string[],
    bank_name?: string[],
    correspondent_account?: string[],
    bank_identification_code?: string[],
    signer_fio?: string[],
    signer_position?: string[],
    signer_basis?: string[],
    signatory_position_and_name?: string[],
    contract_number?: string[],
    contract_date?: string[],
};

export const DealerCreateFormErrorsSchema = z.object({
    holding_id: z.array(z.string()).optional(),
    sap_code: z.array(z.string()).optional(),
    city_id: z.array(z.string()).optional(),
    name: z.array(z.string()).optional(),
    is_certified: z.array(z.string()).optional(),
    is_hyundai_dealer: z.array(z.string()).optional(),
    is_genesis_dealer: z.array(z.string()).optional(),
    phone: z.array(z.string()).optional(),
    email: z.array(z.string()).optional(),
    site: z.array(z.string()).optional(),

    legal_name: z.array(z.string()).optional(),
    address: z.array(z.string()).optional(),
    inn: z.array(z.string()).optional(),
    kpp: z.array(z.string()).optional(),
    ogrn: z.array(z.string()).optional(),
    bank_account: z.array(z.string()).optional(),
    bank_name: z.array(z.string()).optional(),
    correspondent_account: z.array(z.string()).optional(),
    bank_identification_code: z.array(z.string()).optional(),
    signer_fio: z.array(z.string()).optional(),
    signer_position: z.array(z.string()).optional(),
    signer_basis: z.array(z.string()).optional(),
    signatory_position_and_name: z.array(z.string()).optional(),
    contract_number: z.array(z.string()).optional(),
    contract_date: z.array(z.string()).optional(),
});
